






















































import { Component, Vue, Watch, Prop } from "vue-property-decorator";
import cPopup from "@/components/default/Popup.vue";
import listsRepository from "@/services/listsRepository";
import axios from "axios";
import {
  CommunicationsClient,
  CreateNoteCommunicationCommand,
  NoteType,
  NoteTypesClient,
  UpdateNoteCommunicationCommand,
} from "@/data/web-api-client";
import AxiosClient from "@/data/AxiosClient";
import notificationService from "@/services/notificationService";

import {
  DxForm,
  DxSimpleItem,
  DxRequiredRule,
  DxGroupItem,
  DxItem,
  DxLabel,
} from "devextreme-vue/form";

@Component({
  components: {
    cPopup,
    DxSimpleItem,
    DxForm,
    DxLabel,
    DxRequiredRule,
    DxItem,
  },
})
export default class CommunicationNotePopup extends Vue {
  @Prop({ required: true })
  private listName!: string;

  @Prop({ required: true })
  private projectId!: string;

  private show: boolean = false;
  private loading: boolean = false;
  private saving: boolean = false;

  private noteTypesList: NoteType[] = [];

  // private noteTypes!: NoteType[];

  private note = {
    id: "",
    body: "",
    noteTypeName: "",
    noteTypeIcon: "",
    noteTypeId: ""
  };

  public Open(note: any) {
    this.show = true;
    if (note != null) {
      this.note = note;
    }
  }

  public Close() {
    this.show = false;
  }

  private mounted() {
    this.loadData();
  }

  private async save() {
    const form: any = this.$refs.noteForm;
    const validationResult = form.instance.validate();

    if (!validationResult.isValid) {
      notificationService.invalidForm();
      return;
    }

    var client = new CommunicationsClient(undefined, AxiosClient);

    if (this.note.id == "") {
      await client.postAddNote(
        new CreateNoteCommunicationCommand({
          ownerId: this.projectId,
          ownerTableName: "Project",
          body: this.note.body,
          noteTypeId: this.note.noteTypeId,
          noteTypeIcon: this.noteTypesList.find(x => x.id == this.note.noteTypeId)!.icon,
          noteTypeName: this.noteTypesList.find(x => x.id == this.note.noteTypeId)!.value,
        })
      );
    } else {
      await client.postUpdateNote(
        new UpdateNoteCommunicationCommand({
          id: this.note.id,
          body: this.note.body,
          noteTypeId: this.note.noteTypeId,
          noteTypeIcon: this.noteTypesList.find(x => x.id == this.note.noteTypeId)!.icon,
          noteTypeName: this.noteTypesList.find(x => x.id == this.note.noteTypeId)!.value,
        })
      );
    }

    this.$emit("saved");
    this.show = false;
  }

  private async loadData() {

    this.noteTypesList = await new NoteTypesClient(undefined, axios).getAll();
    // await listsRepository.getSingle(this.listName).then((result) => {
    //   for (var value of result.data.values) {
    //     this.noteTypesList.push({ value: value });
    //   }
    //   if (this.noteTypesList.length > 0) {
    //     this.note.noteTypeName = this.noteTypesList[0].value;
    //   }
    // });
  }

  get noteTypes() {
    return {
      items: this.noteTypesList,
      icon: "icon",
      valueExpr: "id",
      displayExpr: "value",
    };
  }

  get htmlEditorOptions() {
    return {
      toolbar: {
        items: [
          "bold",
          "italic",
          "underline",
          "separator",
          "alignLeft",
          "alignCenter",
          "alignRight",
          "alignJustify",
          "separator",
          "orderedList",
          "bulletList",
          "separator",
          "link",
          "separator",
          {
            formatName: "size",
            formatValues: [
              "8pt",
              "10pt",
              "12pt",
              "14pt",
              "18pt",
              "24pt",
              "36pt",
            ],
          },
          {
            formatName: "header",
            formatValues: [false, 1, 2, 3, 4, 5],
          },
        ],
      },
    };
  }
}
